import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { SignupPage } from "@/components/pages/SignupPage";
import { getStoredToken, isTokenExpired } from "@/types";
import { getPendingResume } from "@/lib/pendingResume";
import type { AuthUser } from "@/types";

export function SignupRoute() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = getStoredToken();
    if (token && !isTokenExpired(token)) {
      navigate("/candidates", { replace: true });
    }
  }, [navigate]);

  const handleSignup = (_user: AuthUser, _token: string) => {
    const dest = getPendingResume() ? "/screen" : "/candidates";
    navigate(dest, { replace: true });
  };

  return <SignupPage onSignup={handleSignup} />;
}
